import React, { useState, useCallback, useEffect } from 'react';
import { SurveyFormatRef } from '~app/components/Survey/SurveyFormat';
import useLayoutEffect from '~app/hooks/useIsomorphicLayoutEffect';

const useCenterContainerOffset = (
  centerTarget: SurveyFormatRef | undefined,
  viewportExclusions: React.RefObject<HTMLElement>[],
  heightExclusions: React.RefObject<HTMLElement>[],
  adjustment?: (margin: number) => number
): number => {
  const [offsetTop, setOffsetTop] = useState<number>(0);
  const calculateOffsetTop = useCallback(() => {
    const winH = window.innerHeight;
    const targetContainer = centerTarget?.ref;
    const targetContainerHeight = targetContainer?.current?.offsetHeight ?? 0;
    const viewport = winH - viewportExclusions.reduce((a, ref) => a + (ref.current?.offsetHeight || 0), 0);
    const excludeHeight = heightExclusions.reduce((a, ref) => a + (ref.current?.offsetHeight || 0), 0);
    let margin = targetContainerHeight > 0 ? Math.max(10, viewport / 2 - targetContainerHeight / 2 - excludeHeight) : 0;
    margin = adjustment?.(margin) || margin;
    setOffsetTop(margin);
  }, [centerTarget, viewportExclusions, heightExclusions, adjustment]);

  useLayoutEffect(() => {
    window.addEventListener('resize', calculateOffsetTop);
    return () => window.removeEventListener('resize', calculateOffsetTop);
  }, [calculateOffsetTop]);

  useEffect(() => {
    calculateOffsetTop();
  }, [centerTarget, calculateOffsetTop, viewportExclusions, heightExclusions]);

  return offsetTop;
};

export default useCenterContainerOffset;
